exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-571e7a5e]{margin-bottom:15px;font-size:.75rem}.card-header[data-v-571e7a5e]{background-color:#1e88e5;color:#fff;font-size:.95rem!important;padding:.1rem 1rem}.card-header [data-v-571e7a5e]{color:#fff}.borderless .list-group-item[data-v-571e7a5e],.borderless td[data-v-571e7a5e],.borderless th[data-v-571e7a5e]{border:none}.order-activity .list-group .list-group-item[data-v-571e7a5e]{border-left:none;border-right:none}.order-activity .list-group .list-group-item[data-v-571e7a5e]:first-child{border-top:none}.order-activity .list-group .list-group-item[data-v-571e7a5e]:last-child{border-bottom:none}.btn-group-vertical[data-v-571e7a5e]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-571e7a5e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Orders/ShowPendingModal.vue
// module id = eGvw
// module chunks = 1